import script from "./BaseCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseCard.vue?vue&type=script&setup=true&lang=ts"

import "./BaseCard.vue?vue&type=style&index=0&id=80dad8ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80dad8ac"]])

export default __exports__